import { createVuetify } from 'vuetify';
import 'vuetify/styles';

export default createVuetify({
  theme: {
    // Vuetify 4 defaults to following the OS colour scheme. The site has only
    // ever had a light theme, so pin it.
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#002E5D',
          error: '#FF5252',
          info: '#2196F3',
        },
      },
      dark: {
        colors: {
          primary: '#002E5D',
          error: '#FF5252',
          info: '#2196F3',
        },
      },
    },
  },
  defaults: {
    // Vuetify 2 used the primary colour for active switches by default.
    VSwitch: {
      color: 'primary',
    },
    // Vuetify 2 drew inputs without a variant as an underline; Vuetify 4
    // fills them with a grey box.
    VTextField: { variant: 'underlined' },
    VTextarea: { variant: 'underlined' },
    VSelect: { variant: 'underlined' },
    VAutocomplete: { variant: 'underlined' },
    VCombobox: { variant: 'underlined' },
    VFileInput: { variant: 'underlined' },
  },
  display: {
    // Vuetify 4 narrowed the md/lg/xl breakpoints. The layouts here were built
    // against the Vuetify 2 values, so keep those.
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
      xxl: 2560,
    },
  },
  icons: {
    defaultSet: 'mdi',
  },
});
